export default __webpack_public_path__ + "static/media/image-5.c016fef9.jpg";